module.exports = __webpack_public_path__ + "img/中国建设银行.9e3aa5fd.png";